import React from "react";
import { Link } from "react-router-dom";
import { routeNames } from "../../../routes/routeNames";
import withAnimation from "../../../hooks/withAnimation";

const BlogSection = ({ blogs = [] }) => {
  return (
    <section className="bg-gray-50 py-16">
      <div className="container mx-auto px-6 lg:px-20">
        <h2 className="text-4xl font-extrabold text-center text-primary mb-12">
          Our Blog
        </h2>

        {/* Featured Blog */}
        {blogs.length > 0 && (
          <div className="relative bg-white shadow-lg rounded-xl overflow-hidden mb-16">
            <img
              src={blogs[0].imageUrl}
              alt={blogs[0].title}
              className="w-full h-96 object-cover"
            />
            <div className="absolute inset-0 bg-black bg-opacity-60 flex flex-col justify-end p-8">
              <h3 className="text-4xl font-bold text-white mb-4">
                {blogs[0].title}
              </h3>
              <p className="text-lg font-semibold text-gray-300 mb-6">{blogs[0].excerpt}</p>
              <Link
                to={`/blog/${blogs[0].id}`}
                className="bg-primary w-full md:w-1/3 lg:w-1/4 text-center text-white py-2 px-6 rounded-full inline-block hover:bg-secondary transition duration-300"
              >
                Read More
              </Link>
            </div>
          </div>
        )}

        {/* Blog Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12">
          {blogs.slice(1).map((blog) => (
            <div
              key={blog.id}
              className="bg-white shadow-md rounded-lg overflow-hidden"
            >
              <img
                src={blog.imageUrl}
                alt={blog.title}
                className="w-full h-48 object-cover"
              />
              <div className="p-6">
                <h3 className="text-2xl font-bold text-primary mb-3">
                  {blog.title}
                </h3>
                <p className="text-gray-600 mb-6">{blog.excerpt}</p>
                <Link
                  to={`/blog/${blog.id}`}
                  className="text-primary font-semibold hover:underline"
                >
                  Read More &rarr;
                </Link>
              </div>
            </div>
          ))}
        </div>

        {/* Pagination */}
        {/* <div className="mt-12 flex justify-center">
          <button className="bg-primary text-white py-2 px-6 rounded-full mr-2 hover:bg-secondary transition duration-300">
            Previous
          </button>
          <button className="bg-primary text-white py-2 px-6 rounded-full ml-2 hover:bg-secondary transition duration-300">
            Next
          </button>
        </div> */}
      </div>
    </section>
  );
};

export default withAnimation(BlogSection);
